export default __webpack_public_path__ + "static/media/werise-horizontal-negative.628e1a38.svg";